/* MaxPrint v78 - small fixes that are NOT campaign specific. Loaded with defer on every page from
   layout/theme.liquid. Read-only towards the store: no cart / form changes.
   1. Predictive search: /ar/search/suggest answers 417 "Unsupported buyer locale", which left the dropdown
      on an endless skeleton (theme.js expects a .search-ajax block). When a predictive-search request fails we
      hand theme.js one row instead: "Search results for <q>" -> the full search page. The label is the theme's
      own translation (search.general.title_with_terms), passed in data-mx-search by layout/theme.liquid.
   2. Floating buttons: while an add-to-cart / buy / checkout button sits in the bottom zone of the screen, the
      Gift Advisor button (#mxai-btn) and the WhatsApp mascot (#mx-mascot) fade away (html.mx-float-away).
   3. Search category select: hidden (.mx-sb-tight on the form) when the bar leaves < 200 px for the input. */
(function () {
  'use strict';
  var D = document, W = window, H = D.documentElement;
  var me = D.currentScript;
  var tpl = (me && me.getAttribute('data-mx-search')) || 'Search results for "%Q%"';
  /* the t filter already escapes, so the attribute arrives once-escaped (&quot;): decode it to plain text */
  if (tpl.indexOf('&') > -1) { var ta = D.createElement('textarea'); ta.innerHTML = tpl; tpl = ta.value; }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------------------------------------------------------------- 1. predictive search fallback */
  var nativeFetch = W.fetch;
  if (nativeFetch && W.Response && !W.__mxSearchFallback) {
    W.__mxSearchFallback = true;
    var fallback = function (url) {
      var q = '';
      try { q = new URL(url, location.href).searchParams.get('q') || ''; } catch (e) {}
      q = q.replace(/^product_type:.*? AND /, '');
      var root = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
      var href = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
      var label = esc(tpl).split('%Q%').join(esc(q));
      var html = '<div class="search-ajax"><a class="search-bar__view-all link" data-mx-search-fallback href="' + esc(href) + '">' + label + '</a></div>';
      return new W.Response(html, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
    };
    W.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (url.indexOf('/search/suggest') === -1 || url.indexOf('section_id=predictive-search') === -1) return p;
      return p.then(function (res) {
        if (res.ok) return res;
        return fallback(url);
      }, function () { return fallback(url); });
    };
  }

  /* ---------------------------------------------------------------- 2. floating buttons step aside */
  var SEL = '.product-form .product-form__add-button, .product-form .shopify-payment-button, ' +
            'button[name="checkout"], input[name="checkout"], .cart-recap__checkout';
  var ZONE = 170, io = null, seen = new Set(), rt = 0;
  function setAway() { H.classList.toggle('mx-float-away', seen.size > 0); }
  function watch() {
    if (!('IntersectionObserver' in W)) return;
    if (io) io.disconnect();
    seen.clear(); setAway();
    var targets = Array.prototype.slice.call(D.querySelectorAll(SEL));
    if (!targets.length) return;
    var top = Math.max(0, W.innerHeight - ZONE);
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
      setAway();
    }, { rootMargin: (-top) + 'px 0px 0px 0px', threshold: 0 });
    targets.forEach(function (t) { io.observe(t); });
  }
  function init() {
    watch();
    W.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(watch, 200); }, { passive: true });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();

  /* ---------------------------------------------------------------- 3. search category select steps aside */
  /* theme.css shows "All categories" from 1280 px; with long labels (or a signed-in name) the bar can get too
     narrow for it. Keep >= 200 px for the input, otherwise hide the select (.mx-sb-tight). */
  function sbWatch() {
    var top = D.querySelector('.header .search-bar__top'), form = top && top.closest('.search-bar');
    if (!top || !form || !('ResizeObserver' in W)) return;
    var MIN = 200;
    new W.ResizeObserver(function () {
      var f = top.querySelector('.search-bar__filter'), sub = top.querySelector('.search-bar__submit');
      if (!f) return;
      form.classList.remove('mx-sb-tight');
      if (W.getComputedStyle(f).display === 'none') return;
      var room = top.clientWidth - f.getBoundingClientRect().width - (sub ? sub.getBoundingClientRect().width : 50);
      if (room < MIN) form.classList.add('mx-sb-tight');
    }).observe(top);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', sbWatch); else sbWatch();
})();
